import React, { useState } from "react";

import Languages from "../../../../translations";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const LeopsPreviousSupport = ({ rows }) => {
  const [expanded, setExpanded] = useState(false);

  if (!rows || rows.length === 0) return null;

  const titles = [
    Languages.ChildPrevSupportInEC,
    Languages.ParentelThoughts,
    Languages.ChildStrengthsAndInterestsLearningNeeds,
  ];

  return (
    <Accordion
      className="painikkeet"
      style={{ backgroundColor: "#4377BA" }}
      expanded={expanded}
      onChange={() => setExpanded(!expanded)}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel-previous-support-content"
      >
        <Typography className="heading">{Languages.PreviousSupport}</Typography>
      </AccordionSummary>
      <div style={{ backgroundColor: "#ffffff" }}>
        {rows.map((row, index) =>
          row?.RowText || row?.Editor ? (
            <AccordionDetails key={`prev-support-${index}`}>
              <Typography
                color="textSecondary"
                sx={{
                  textAlign: "left",
                  fontWeight: "bold",
                  fontSize: 14,
                  color: "#424242",
                  pt: 1,
                  ml: 1,
                }}
              >
                {titles[index] ?? ""}
              </Typography>
              <Box
                sx={{
                  backgroundColor: "#ffffff",
                  borderRadius: 2,
                  boxShadow: 2,
                  whiteSpace: "pre-line",
                  overflowWrap: "break-word",
                  mt: 1,
                  pt: 2,
                  pb: 2,
                  px: 1,
                }}
              >
                <Typography
                  sx={{
                    textAlign: "left",
                    fontSize: 16,
                    color: "#424242",
                  }}
                >
                  {(row.Editor ?? "") + "\n" + (row.RowText ?? "")}
                </Typography>
              </Box>
            </AccordionDetails>
          ) : null,
        )}
      </div>
    </Accordion>
  );
};

export default LeopsPreviousSupport;
